import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { TutorReportItem, TutorReport } from '../models';

export class TutorReportApi extends ApiModule {
  protected endpoint = '/tutor-report';

  public async pageTutorReports(params: any) {
    return this.api.post<PaginatedResponseData<TutorReportItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? 'fromDate,desc'}`,
      {
        ...params,
        sort: params.sort ?? 'fromDate,desc'
      }
    );
  }

  public loadTutorReportDetails(id: number) {
    return this.api.get<TutorReport>(`${this.endpoint}?id=${id}`);
  }

  public saveTutorReport(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params,
      workSchedule: params.value
    });
  }

  public calculateTutorReport(id: number): Promise<any> {
    return this.api.get<TutorReport>(`${this.endpoint}/calculate?tutorId=${id}`);
  }

  public deleteTutorReport(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public async savePaymentIndicationMessage(params: any) {
    return this.api.post(`${this.endpoint}/save-payment-indication-message`, {
      ...params
    });
  }
}
